module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./MsgAddView.js"));
	}, "MsgAddView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=MsgAddView!./src/pages/Shop/Member/MsgAdd/MsgAddView.js
// module id = 976
// module chunks = 431